export const ADMINISTRATION_MAIN_TABLES_PAGE_LENGTH = 20;
export const REPORT_TABLES_PAGE_LENGTH = 20;
export const QR_CODE_SIDELENGTH = 180;
export const QR_CODE_LARGE_SIDELENGTH = 344;
export const QR_CODE_PRINT_SIDELENGTH = 150;
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;
export type Weekday = typeof WEEKDAYS[number];
export const GROUP_TIME_NAV_BAR = "timeNavigationBar";
export const GROUP_RECORDING_VALIDATIONS = "recordingValidations";
export const GROUP_REPORT_FILTER = "recordingReportFilter";
